"use client";

import { AIExplanation } from "./_components/ai_explanation";

export default function EthicalAI() {
	return (
		<main className="my-20 flex flex-col items-center justify-center sm:mb-40" role="main" aria-label="Ethical AI">
			<div className="w-full max-w-(--breakpoint-lg) px-4">
				<AIExplanation />
			</div>
		</main>
	);
}
